import React from 'react'
import { Button } from 'reactstrap'

const CustomizedButton = ({
  cn,
  children,
  onClick,
  href,
  size,
  color,
  style,
}) => {
  return (
    <Button
      aria-pressed={true}
      className={cn}
      style={style}
      color={color}
      href={href}
      onClick={onClick}
      role='button'
      size={size}
    >
      {children}
    </Button>
  )
}

export default CustomizedButton
